import { useI18n } from '@/shared/i18n';
import { Group, Text } from '@mantine/core';
import { Button } from './Button';
import { Modal } from './Modal';

export function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  isSubmitting = false,
  confirmVariant = 'danger',
}: {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  /** Use danger for destructive; primary for financial confirm when appropriate. */
  confirmVariant?: 'danger' | 'primary';
}) {
  const { t } = useI18n();

  return (
    <Modal isOpen={isOpen} title={title} onClose={onCancel}>
      <Text size="sm">{message}</Text>
      <Group justify="flex-end" gap="sm" mt="lg">
        <Button variant="ghost" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button variant={confirmVariant} isLoading={isSubmitting} onClick={onConfirm}>
          {confirmLabel ?? t('common.confirm')}
        </Button>
      </Group>
    </Modal>
  );
}
